import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { SimPackages } from "../../API/Sim";
import Title from "../../new-components/title/Title";
import HeaderInner from "../../Components/HeaderInner";
import { Accordion, Form } from "react-bootstrap";
import "bootstrap/dist/css/bootstrap.min.css";
import CustomBusinessServiceLoader from "../../Components/Loaders/CustomBusinessServiceLoader";

const E_SimCountries = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const rawPath = location.pathname;
  const { t } = useTranslation();

  const room_uuid = rawPath.split("/")[1];
  const { company_id, type } = useParams();
  const lang = localStorage.getItem("lang");
  const new_design = localStorage.getItem("new_design");
  const theme = new_design === "true";

  const { data, isLoading } = SimPackages(room_uuid, lang, company_id, type);

  const countries = data?.data?.data || [];

  const [searchTerm, setSearchTerm] = useState("");

  // Filter countries by title if search is active and type is local
  const filteredCountries =
    type === "local"
      ? countries.filter((country) =>
          country.title.toLowerCase().includes(searchTerm.toLowerCase())
        )
      : countries;

  useEffect(() => {
    if (!isLoading && filteredCountries.length === 1 && type === "world") {
      const onlyCountry = filteredCountries[0];
      navigate(`/${room_uuid}/sims/${company_id}/${onlyCountry.slug}/options`, {
        state: { region: onlyCountry },
        replace: true,
      });
    }
  }, [filteredCountries, isLoading, type, navigate, room_uuid, company_id]);

  return (
    <div className={`${theme && "food"} ${lang === "AR" && "arabic"}`}>
      {theme ? (
        <Title title={t("eSIM")} />
      ) : (
        <HeaderInner headerName={t("eSIM")} />
      )}

      {isLoading ? (
        <CustomBusinessServiceLoader businessName="Countries" loader="spa" />
      ) : (
        <main className="box_food image_services home-main bg-white back-white">
          {type === "local" && (
            <div className="p-3">
              <Form.Control
                type="text"
                placeholder={t("Search country")}
                value={searchTerm}
                onChange={(e) => setSearchTerm(e.target.value)}
              />
            </div>
          )}

          {filteredCountries.length > 0 ? (
            <div className="" style={{ margin: "5px" }}>
              <Accordion
                multiple
                defaultActiveKey={null}
                className="countries-acc"
              >
                {filteredCountries.map((country, index) => (
                  <Accordion.Item
                    eventKey={index.toString()}
                    key={country.slug}
                    onClick={() =>
                      navigate(
                        `/${room_uuid}/sims/${company_id}/${country.slug}/options`,
                        { state: { region: country } }
                      )
                    }
                    className="item"
                  >
                    <Accordion.Header className="acc-header">
                      <p
                        style={{
                          color: theme ? "white" : "black",
                          fontWeight: 500,
                          marginTop: "5px",
                        }}
                      >
                        {country.title}
                      </p>
                      {country.image_url && (
                        <img
                          src={country.image_url}
                          alt={country.title}
                          style={{
                            width: "24px",
                            height: "24px",
                            marginRight: "10px",
                            objectFit: "cover",
                            borderRadius: "4px",
                          }}
                        />
                      )}
                    </Accordion.Header>
                  </Accordion.Item>
                ))}
              </Accordion>
            </div>
          ) : (
            <div className="text-center p-4">
              {t("No countries available.")}
            </div>
          )}
        </main>
      )}
    </div>
  );
};

export default E_SimCountries;
